import { xUnits } from '../../../UNSAFE_Theme/utils';

export const scaleSchemeMd = {
  iconSize: '',
  sizes: {
    xs: {
      iconSize: 'max(' + xUnits(5) + ', 20px)'
    },
    sm: {
      iconSize: xUnits(5)
    },
    md: {
      iconSize: xUnits(5.714)
    },
    lg: {
      iconSize: xUnits(5.714)
    },
    embeddedxs: {
      iconSize: 'max(' + xUnits(5) + ', 20px)'
    },
    embeddedsm: {
      iconSize: xUnits(5)
    },
    embeddedmd: {
      iconSize: xUnits(5.714)
    },
    embeddedlg: {
      iconSize: xUnits(5.714)
    }
  }
};
